import React from 'react';
/* --- import Components ----*/
import { Section } from '../Section';
import { Paragraph, SectionTitle } from '../Typography';
import { Line } from 'src/style/lines';
import LogoInstitutionals from './LogoInstitutionals';
import ButtonScrollToForm from './ButtonScrollToForm';
/* --- import Styles ----*/
import colors from 'src/style/colors';
import { useMediaQueries } from 'src/utils/MediaQueries';

const FinancingLandingPage = ({ fromPage }) => {
  const mqs = useMediaQueries();
  return (
    <Section landing>
      <SectionTitle isMobileCenter isCenter css={{ marginBottom: 40 }}>
        Des options{mqs.phoneOnly ? <br></br> : ' '}de{' '}
        <span css={{ color: colors.purple }}>financements</span>
        {mqs.desktopUp ? ' ' : <br></br>}adaptées à vos besoins
      </SectionTitle>
      <Paragraph css={{ paddingBottom: 12 }}>
        Vous voulez réellement apprendre à coder mais le coût de la formation est un frein&nbsp;?
        <br></br>
        Bonne nouvelle&nbsp;! De nombreux dispositifs existent pour vous aider à financer votre
        reconversion dans la programmation. <br></br>
        <br></br>Nous sommes à votre disposition pour :
      </Paragraph>
      <ul css={{ marginBottom: fromPage !== 'reunion' && 60 }}>
        <li
          css={{
            display: 'flex',
            alignItems: 'start',
          }}
        >
          <Line css={{ marginTop: 12, minWidth: 22 }} />
          <Paragraph css={{ paddingTop: 0, paddingBottom: 5 }}>
            vous accompagner au mieux dans la construction de votre dossier
          </Paragraph>
        </li>
        <li
          css={{
            display: 'flex',
            alignItems: 'start',
          }}
        >
          <Line css={{ marginTop: 12, minWidth: 22 }} />
          <Paragraph css={{ paddingTop: 0, paddingBottom: 5 }}>
            vous proposer les différentes options existantes selon votre profil, dont des aides du
            gouvernement ou le paiement en plusieurs fois.
          </Paragraph>
        </li>
      </ul>
      {fromPage === 'reunion' && (
        <Paragraph css={{ marginBottom: 60 }}>
          Nous aborderons ce sujet au cours de la réunion d’information.
        </Paragraph>
      )}
      <LogoInstitutionals />
      <ButtonScrollToForm
        text={
          fromPage === 'reunion'
            ? `Je participe à la réunion d'information\u00A0!`
            : `Je postule\u00A0!`
        }
      />
    </Section>
  );
};

export default FinancingLandingPage;
